module.exports = __webpack_public_path__ + "img/dianchi-100.7c26ac81.png";